import { ReactNode } from 'react';

import { cn } from '../../lib';

interface TLoadingGradientTextProps {
  children?: ReactNode | ReactNode[];
  className?: string;
  isLoading?: boolean;
}

/**
 * -----------------------------------------------------------------------------
 * This component displays a loading text animation with an animated gradient
 * background that's clipped by the text.
 *
 * - Use this in cases like animated buttons or loading states.
 */
export function LoadingGradientText({
  children,
  className,
  isLoading,
}: TLoadingGradientTextProps) {
  return (
    <span
      className={cn(
        isLoading &&
          `
          animate-gradient bg-linear-60 from-gray-200/45 from-20% via-gray-800/75
          via-45% to-gray-700/20 to-75% bg-clip-text text-gray-200/10
        `,
        className
      )}
    >
      {children}
    </span>
  );
}
